"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M17.03 5L3 5.01v13.98l14.03.01L22 12l-4.97-7z"
}), 'LabelSharp');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/LabelSharp.js
// module id = 3163
// module chunks = 0